export default "__VITE_ASSET__CRMgNhqn__"